module.exports = __webpack_public_path__ + "img/publishGood.0bdabe4.png";